'use client';

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export default function SocialVsWebSection() {
  const { t } = useLanguage();

  return (
    <section
      id="per-que-web"
      className="py-24 px-6 bg-[#050507] relative overflow-hidden border-t border-white/5"
      aria-label="Xarxes socials vs Web pròpia"
    >
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-96 h-96 bg-purple-brand/10 blur-[130px] pointer-events-none" />

      <div className="max-w-7xl mx-auto space-y-16 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-gold/30 bg-gold/5 text-gold text-[11px] font-bold uppercase tracking-widest">
            {t.socialVsWeb.badge}
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight uppercase">
            {t.socialVsWeb.title}
          </h2>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            {t.socialVsWeb.sub}
          </p>
        </div>

        {/* 2-Column Comparison Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {/* Card 1: Social Media Only */}
          <div className="rounded-3xl p-8 bg-gradient-to-b from-[#131016] to-[#0c0a0f] border border-rose-950/40 relative overflow-hidden space-y-6">
            <div className="space-y-2">
              <span className="inline-block text-[11px] font-extrabold uppercase tracking-widest text-rose-400 bg-rose-500/10 px-3 py-1 rounded-full border border-rose-500/20">
                {t.socialVsWeb.socialTag}
              </span>
              <h3 className="text-2xl font-black text-white">
                {t.socialVsWeb.socialTitle}
              </h3>
              <p className="text-xs sm:text-sm text-slate-400">
                {t.socialVsWeb.socialSubtitle}
              </p>
            </div>

            <ul className="space-y-4 pt-2">
              {t.socialVsWeb.socialPoints.map((point, index) => (
                <li key={index} className="flex items-start gap-3.5 text-slate-300 text-xs sm:text-sm leading-snug">
                  <span className="w-5 h-5 rounded-full bg-rose-500/20 text-rose-400 flex items-center justify-center font-bold text-xs flex-shrink-0 mt-0.5">
                    ✕
                  </span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <div className="pt-4 border-t border-white/5 text-[11px] text-slate-400 italic">
              {t.socialVsWeb.socialQuote}
            </div>
          </div>

          {/* Card 2: Own Website with Onix */}
          <div className="rounded-3xl p-8 bg-gradient-to-b from-[#141524] to-[#0d0e18] border border-gold/40 shadow-xl shadow-gold/5 relative overflow-hidden space-y-6">
            {/* Top golden accent line */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-gold via-magenta-brand to-purple-brand" />

            <div className="space-y-2">
              <span className="inline-block text-[11px] font-extrabold uppercase tracking-widest text-gold bg-gold/10 px-3 py-1 rounded-full border border-gold/30">
                {t.socialVsWeb.webTag}
              </span>
              <h3 className="text-2xl font-black text-white">
                {t.socialVsWeb.webTitle}
              </h3>
              <p className="text-xs sm:text-sm text-slate-300">
                {t.socialVsWeb.webSubtitle}
              </p>
            </div>

            <ul className="space-y-4 pt-2">
              {t.socialVsWeb.webPoints.map((point, index) => (
                <li key={index} className="flex items-start gap-3.5 text-slate-200 text-xs sm:text-sm leading-snug">
                  <span className="w-5 h-5 rounded-full bg-emerald-500/20 text-emerald-400 flex items-center justify-center font-bold text-xs flex-shrink-0 mt-0.5">
                    ✓
                  </span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <div className="pt-4 border-t border-white/5 text-[11px] text-gold font-medium">
              {t.socialVsWeb.webQuote}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
